/* eslint-disable */
import axios from '../index'

const getAll = () => {
  return axios.get('currency')
}
const getAllCurrencies = () => {
  return axios.get('currency/all')
}
const getWithDate = (date) => {
  return axios.get(`list?date=${date}`)
}

const api = { getAll, getAllCurrencies, getWithDate }


export default api;